// extracted by css-extract-rspack-plugin
module.exports =  {"news-list":"NewsList-fwpf__news-list"};